import { ChartGranularity } from "shared/enums/ChartGranularityEnum";
import moment from "moment";

export const getDefaultFromAndToDate = (granularity: ChartGranularity) => {
  if (granularity === ChartGranularity.Monthly) {
    return [moment().subtract(1, "month"), moment()];
  }
  return [moment().startOf("year"), moment()];
};
